<template>
    <div>
        <div class="errors" v-if="$validator.errors">
            <small v-for="(error, index) in $validator.errors.items" v-bind:key="index">
                {{ error.msg }}
            </small>
        </div>
        <custom-input name="email" ref="email" type="text" :validationRules="{ required: true, email: true }" v-model="email" placeholder="Email" autocomplete="email"/>
        <custom-input name="password" ref="password" type="password" :validationRules="{ required: true }" v-model="password" placeholder="Password" autocomplete="current-password" @keyup.enter.native="validate"/>

        <div class="footer">
            <button v-if="onCancel" class="secondary" type="button" v-on:click="onCancel">{{cancelText?cancelText:'Cancel'}}</button>
            <button class="primary" type="button" v-on:click="validate">Login</button>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput.vue';
import { eventBus } from '../main';

export default {
    name: 'login',
    mixins: [
        Default
    ],
    props: [
        'onComplete',
        'onCancel',
        'cancelText'
    ],
    inject: {
        $validator: '$validator'
    },
    components: {
        customInput
    },
    data() {
        return {
            email: '',
            password: '',
            nothing: '',
            userIsActivated: false // DEBUG
        };
    },
    methods: {
        validate: function() {
            this.$parleyAdmin.validateMultiple([this.$refs.email, this.$refs.password], function(value) {
                if (value)
                    return this.login();
                else
                    return false;
            }.bind(this));
        },
        login: function() {
            this.$validator.errors.clear();

            return this.$http.post('v1.1/auth/login', {
                email: this.email,
                password: this.password
            }).then(response => {
                // Save the user object in the vuex store
                const user = response.data.data.user;

                // Broadcast that the user is loggedin
                eventBus.$emit('userLoggedin');

                const setUserPromise = this.$store.dispatch(this.$store.types.user.actions.set, user);
                const setTempTokenPromise = this.$store.dispatch(this.$store.types.token.actions.set_temp, {
                    token: response.data.auth.token,
                    expireTime: response.data.auth.expireTime
                });

                Promise.all([setUserPromise, setTempTokenPromise]).then(() => {
                    // Get the user object and check what to navigate next
                    const userState = this.$store.getters[this.$store.types.user.getters.get];
                    this.setup = !userState.activated;

                    if (this.onComplete)
                        this.onComplete();
                    else {
                        if (userState.shouldChangePassword)
                            this.$router.push({name: 'changePassword', params: {callback: this.callback, initialPasswordChange: true}}); // Redirect to password change TODO: Put initialPasswordChange into vuex and mixins
                        else
                            this.$router.push({name: 'tfaCheck', params: {callback: this.callback, setup: this.setup}});
                    }
                });
            }, response => {
                // Error callback
                let notifications = JSON.parse(response.bodyText).notifications;
                if (notifications.filter((element) => { return element.message === 'combination_invalid'; }).length > 0)
                    this.$validator.errors.add({
                        field: '',
                        msg: 'Email and password combination invalid'
                    });
                else
                    this.$validator.errors.add({
                        field: '',
                        msg: 'Something went wrong while trying to login, please try again later'
                    });
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .errors {
        small {
            color: red;
        }
        padding-bottom: 1em;
    }

    .custom-input {
        width: 34em;
    }

    button {
        width: 5em;
        height: 3em;
        line-height: inherit;
    }
</style>
